exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.setting_heading[data-v-5ed5fb70]{\n  height: 28.8px;\n}\n", ""]);

// exports
